import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {computed, watch} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import SelectRemote from "@/components/business/crud/common/SelectRemote.vue";
import {MorphFieldType} from "@/components/business/crud/interface/FieldType";
import MorphTable from "@/components/business/crud/widgets/impl/MorphTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MorphForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();
const modelName = computed(() => data.value[props.widget.modelNameProp])
watch(modelName, () => {
  data.value[props.propName] = null;
});

const selectRemove = computed(() => {
  if (!modelName.value) {
    return null;
  }
  const model = props.widget.models[modelName.value];
  if (!model) {
    return null;
  }
  return {
    name: 'selectRemote',
    multi: false,
    path: model.basePath + '/index',
    createPagePath: model.basePath + '/create',
    viewPagePath: model.basePath + '/view',
    labelFieldName: model.labelPropName || "name",
    valueFieldName: 'id'
  }
})

return (_ctx: any,_cache: any) => {
  return (selectRemove.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.info.status === 'edit')
          ? (_openBlock(), _createBlock(SelectRemote, {
              key: 0,
              title: _ctx.info.title,
              widget: selectRemove.value,
              modelValue: _unref(data)[_ctx.propName],
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data)[_ctx.propName]) = $event))
            }, null, 8, ["title", "widget", "modelValue"]))
          : (_openBlock(), _createBlock(MorphTable, _mergeProps({
              key: 1,
              data: _unref(data)
            }, _ctx.$props), null, 16, ["data"]))
      ], 64))
    : _createCommentVNode("", true)
}
}

})